import {Injectable} from '@angular/core';
import {HttpService} from "../../../services/http.service";
import {HttpParams} from "@angular/common/http";
import {TokenService} from "../../../services/auth/token.service";
import {JBMTableColumnDef, IDTag} from "../../../components/JBM/JBMTable/JBMTable.component";
import { da } from 'date-fns/locale';

const baseURL: string = 'users/read/tablelayout/';

type ColumnConfiguration = {
  name: string
  visible: boolean
  width: number
}

@Injectable({
  providedIn: 'root'
})
export class TablelayoutService {
  tableName: string=''
  initialColumnDefs: JBMTableColumnDef[]=[]
  columnDefs: JBMTableColumnDef[]=[]

  constructor( private HttpService: HttpService, private TokenService: TokenService ) {}

  getEmpty() {
    return this.HttpService.get(baseURL+'empty');
  }
  initLayout(tablename: string, columnDefs: JBMTableColumnDef[]) {
    this.tableName=tablename
    this.initialColumnDefs=[...columnDefs]
    this.columnDefs=columnDefs

    this.setLayout()
  }
  setTableColumns(columnDefs: JBMTableColumnDef[]) {
    this.columnDefs=columnDefs
  }
  setLayout(): any {
    let user_id=this.TokenService.getUserId();
    let params=new HttpParams();
    params=params.append('user_id',user_id.toString());
    params=params.append('tablename', this.tableName);
    this.HttpService.getAsPromise(baseURL+'one', params ).then( (data: any)=> {
      if(data.data.hasOwnProperty('layout_configuration')) {
        // Update columns layout if layout has been stored
        this.setColumnsLayout(data.data.layout_configuration);
      }
    }).catch((error: any) => {
      if(error.error==='not_found' && this.columnDefs.length) 
        this.saveLayout()  
    });
  }
  saveLayout() {
    const user_id=this.TokenService.getUserId();
    const initial_layout_configuration: ColumnConfiguration[] = this.initialColumnDefs.map((cd: any) => ({
      name: cd.name, visible: cd.visible ?? true, width: cd.width ?? 0
    }));
    const layoutConfiguration=this.getColumnsLayout();
    this.HttpService.post(baseURL+'create', {
      user_id: user_id,
      tablename: this.tableName,
      initial_layout_configuration: initial_layout_configuration,
      layout_configuration: layoutConfiguration
    }).subscribe();
  }
  setColumnsLayout(layoutConfiguration: ColumnConfiguration[]) {
    // Set the columns in the configurated order
    const orderMap = new Map(layoutConfiguration.map((x: any, i: any) => [x.name, i]));
    this.columnDefs.sort((a: any, b: any) => {
      const ai = orderMap.get(a.name) ?? Number.MAX_SAFE_INTEGER;
      const bi = orderMap.get(b.name) ?? Number.MAX_SAFE_INTEGER;
      return ai - bi;
    });

    for(let columnConfiguration of layoutConfiguration) {
      let index=this.columnDefs.findIndex((cd: any) => cd.name===columnConfiguration.name);
      if(index===-1) continue
      this.columnDefs[index].visible=columnConfiguration.visible
      this.columnDefs[index].width=columnConfiguration.width
    }
  }
  private getColumnsLayout(): ColumnConfiguration[] {
    let layoutConfiguration: ColumnConfiguration[]=[]
    for(let columnDef of this.columnDefs) {
      layoutConfiguration.push( { 
        name: columnDef.name, 
        visible: columnDef.visible ?? true,
        width: columnDef.width || 7
      })
    }
    return layoutConfiguration
  }
}
